export const REP_TYPE_IDS = {
    globalAdmin: 1,
    businessUnitManager: 2,
    regionalSalesManager: 3,
    salesRep: 4,
    experientialRep: 5,
    expLead: 6,
    retailStoreAdmin: 7,
    customerServiceManager: 8,
    customerServiceAgent: 9,
    retailFitterManager: 10,
    retailFitter: 11,
    tourRep: 12,
};

export const ALL_REP_TYPE_IDS = Object.values(REP_TYPE_IDS);

export const REP_TYPES = {
    [REP_TYPE_IDS.globalAdmin]: {
        name: "Global Admin",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.businessUnitManager]: {
        name: "Business Unit Manager",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.regionalSalesManager]: {
        name: "Regional Sales Manager",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.salesRep]: {
        name: "Sales Rep",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.experientialRep]: {
        name: "Experiential Rep",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.expLead]: {
        name: "Exp Lead",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.retailStoreAdmin]: {
        name: "Retail Store Admin",
        defaultRoute: "/retail-locations",
    },
    [REP_TYPE_IDS.customerServiceManager]: {
        name: "Customer Service Manager",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.customerServiceAgent]: {
        name: "Customer Service Agent",
        defaultRoute: "/events",
    },
    [REP_TYPE_IDS.retailFitterManager]: {
        name: "Retail Fitter Manager",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.retailFitter]: {
        name: "Retail Fitter",
        defaultRoute: "/users",
    },
    [REP_TYPE_IDS.tourRep]: {
        name: "Tour Rep",
        defaultRoute: "/sign-in",
    },
};
